import React from 'react'

const Checkbox = props => {
  const { text, isChecked, onChange } = props.fieldData
  return (
    <label className="checkbox">
      <input 
        type="checkbox" 
        checked={isChecked || false}
        onChange={onChange}
      />&nbsp;
      {text}
    </label>
  )
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/generic/Checkbox.js